export default function getFilenameFromUrl(url: string) {
  const workingUrl = url.match(/^https?:.*/) ? url : `http://${url}`
  const pathname = new URL(workingUrl).pathname
  const index = pathname.lastIndexOf("/")
  return -1 !== index ? pathname.substring(index + 1) : pathname
}
